import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { watchaddPartnerSaga } from './saga';
import { AddPartnerState } from './types';

export const initialState: AddPartnerState = {
  isInviting: false,
  invitePartnerSuccessResponse: null,
  inviteFailureResponse: null,
};

const slice = createSlice({
  name: 'addPartner',
  initialState,
  reducers: {
    inviteMember(state, action: PayloadAction<any>) {
      state.isInviting = true;
    },
    inviteMemberSuccess(state, action: PayloadAction<any>) {
      state.isInviting = false;
      state.invitePartnerSuccessResponse = action.payload;
    },
    inviteMemberFailure(state, action: PayloadAction<any>) {
      state.isInviting = false;
      state.inviteFailureResponse = action.payload;
    },
    inviteMemberReset(state) {
      state.isInviting = false;
      state.inviteFailureResponse = null;
      state.invitePartnerSuccessResponse = null;
    },
  },
});

export const { actions: addPartnerActions } = slice;

export const useAddPartnerSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: watchaddPartnerSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useAddPartnerSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
